import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { FarmService } from '../../common/_services';

@Pipe({
  name: 'mycurrency',
  pure: true,
  standalone: false,
})
export class CustomCurrencyPipe implements PipeTransform {
  private preferredCurrency = '';
  constructor(
    private currencyPipe: CurrencyPipe,
    private farmService: FarmService
  ) {
    this.farmService.getPreferredCurrency().subscribe((currency) => {
      this.preferredCurrency = currency;
    });
  }

  transform(value: any, currency: string = this.preferredCurrency, symbol: boolean = true): string {
    if (value != null) {
      let cleanedValue = value.toString();
      if (cleanedValue.includes(',')) {
        cleanedValue = value.replace(/,/g, '');
      }
      return this.currencyPipe.transform(cleanedValue, currency, symbol ? 'symbol' : null);
    }
    return this.currencyPipe.transform(0, currency, symbol ? 'symbol' : null).split('0.00')[0];
  }
}
